import { render, staticRenderFns } from "./CertifiedMessage.vue?vue&type=template&id=ad11ca9a&scoped=true&"
import script from "./CertifiedMessage.vue?vue&type=script&lang=js&"
export * from "./CertifiedMessage.vue?vue&type=script&lang=js&"
import style0 from "./CertifiedMessage.vue?vue&type=style&index=0&id=ad11ca9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad11ca9a",
  null
  
)

export default component.exports